import * as yup from 'yup'

export class CompanyDto {
  companyGuid?: string = undefined
  name?: string = undefined
  logoFileName?: string = undefined
  website?: string = undefined
  notes?: string = undefined
  isActive?: boolean = true
  isAttorneyCompany?: boolean = false
  isBrokerCompany?: boolean = false
  isBuyerCompany?: boolean = false
  isExporterCompany?: boolean = false
  isClusterConversionCompany?: boolean = false
  isClusterProgrammerCompany?: boolean = false
  isInboundTransporterCompany?: boolean = false
  isImporterDealerCompany?: boolean = false
  isInspectionCompany?: boolean = false
  isInsuranceCompany?: boolean = false
  isLienHolderCompany?: boolean = false
  isMichiganSOSBranch?: boolean = false
  isOutboundTransporterCompany?: boolean = false
  isRegisteredImporterCompany?: boolean = false
  isSuretyCompany?: boolean = false
  isTitleDestinationCompany?: boolean = false
  isVehicleDestinationCompany?: boolean = false
  isOwner?: boolean = false
  exporterDealerNumber?: string = undefined
  exporterIRSNumber?: string = undefined
  registeredImporterNumber?: string = undefined
  registeredImporterIRSNumber?: string = undefined
}

export const companyValidationSchema = yup.object<CompanyDto>({
  id: yup.string().nullable(),
  name: yup.string().max(200, 'Company Name cannot be more than 200 characters.').required('Company Name is required.'),
  // logoFileName is read only/changed via uploading a logo, so it is excluded from the validation schema.
  website: yup.string().max(2_083, 'Website cannot be more than 2,083 characters.').nullable(),
  notes: yup.string().max(2_000, 'Notes cannot be more than 2,000 characters.').nullable(),
  isActive: yup.boolean().required('Active is required.'),
  isAttorneyCompany: yup.boolean().required('Attorney Company is required.'),
  isBrokerCompany: yup.boolean().required('Broker is required.'),
  isBuyerCompany: yup.boolean().required('Buyer Company is required.'),
  isExporterCompany: yup.boolean().required('Exporter Company is required.'),
  isClusterConversionCompany: yup.boolean().required('Cluster Conversion Company is required.'),
  isClusterProgrammerCompany: yup.boolean().required('Cluster Programmer Company is required.'),
  isInboundTransporterCompany: yup.boolean().required('Inbound Transporter is required.'),
  isImporterDealerCompany: yup.boolean().required('Importer Dealer Company is required.'),
  isInspectionCompany: yup.boolean().required('Inspection Company is required.'),
  isInsuranceCompany: yup.boolean().required('Insurance Company is required.'),
  isLienHolderCompany: yup.boolean().required('Lien Holder Company is required.'),
  isMichiganSOSBranch: yup.boolean().required('Michigan SOS Branch is required.'),
  isOutboundTransporterCompany: yup.boolean().required('Outbound Transporter is required.'),
  isRegisteredImporterCompany: yup.boolean().required('Registered Importer is required.'),
  isSuretyCompany: yup.boolean().required('Surety Company is required.'),
  isTitleDestinationCompany: yup.boolean().required('Title Destination is required.'),
  isVehicleDestinationCompany: yup.boolean().required('Vehicle Destination is required.'),
  // TODO: Right now, "Registered Importer" is a switch on Companies Add/Edit Dialog, but if they are an Exporter Company,
  // they can never be a Registered Importer, and there is only ever supposed to be 1 Registered Importer company.
  // This may end up being hard coded on the instance.
  buyerCompanies: yup.array().nullable(),
  inboundTransporterCompanies: yup.array().nullable(),
  outboundTransporterCompanies: yup.array().nullable(),
  titleDestinationCompanies: yup.array().nullable(),
  vehicleDestinationCompanies: yup.array().nullable()
})
